"use client";

import { useTranslation } from "@/i18n";

export function HelpPageHeader() {
    const { t } = useTranslation();
    return (
        <div className="mb-16">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-mars mb-4">
                {t.help.eyebrow}
            </p>
            <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-text mb-4">
                {t.help.title}
            </h1>
            <p className="text-lg text-text-secondary leading-relaxed max-w-xl">
                {t.help.description}
            </p>
        </div>
    );
}
